import {useEffect,  Suspense, lazy } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import AOS from "aos";
import NavScrollTop from './components/NavScrollTop';
const Home = lazy(() => import("./pages/Home"));
const About = lazy(() => import("./pages/About"));
const Service = lazy(() => import("./pages/Service"));
const BlogGrid = lazy(() => import("./pages/BlogGrid"));
const BlogDetails = lazy(() => import("./pages/BlogDetails"));
const BlogCategories = lazy(() => import("./pages/BlogCategories"));
const BlogTag = lazy(() => import("./pages/BlogTag"));
const Contact = lazy(() => import("./pages/Contact"));
const Tecnologia = lazy(() => import("./pages/Services_Tecnologia"));
const Civil = lazy(() => import("./pages/Services_Civil"));
const Consultoria = lazy(() => import("./pages/Services_Consul"));
const BlogClassic = lazy(() => import("./pages/BlogClassic"));

function App() {
  useEffect(() => {
    AOS.init({
        offset: 80,
        duration: 1000,
        once: true,
        easing: 'ease',
    });
    AOS.refresh();
    
  }, [])
  return (
      <Router>
        <NavScrollTop>
          <Suspense fallback={<div />}>
                <Routes>
                  <Route path={`${process.env.PUBLIC_URL + "/"}`} element={<Home/>}/>
                  <Route path={`${process.env.PUBLIC_URL + "/home"}`} element={<Home/>}/>
                  <Route path={`${process.env.PUBLIC_URL + "/sobre-nos"}`} element={<About/>} />
                  <Route path={`${process.env.PUBLIC_URL + "/servicos"}`} element={<Service/>} />
                  <Route path={`${process.env.PUBLIC_URL + "/blog"}`} element={<BlogGrid/>} />
                  <Route path={`${process.env.PUBLIC_URL + "/tag/:slug"}`} element={<BlogTag/>} />
                  <Route path={`${process.env.PUBLIC_URL + "/category/:slug"}`} element={<BlogCategories/>} />
                  <Route path={`${process.env.PUBLIC_URL + "/blog-details/:id"}`}element={<BlogDetails/>} />
                  <Route path={`${process.env.PUBLIC_URL + "/contato"}`} element={<Contact/>} />
                  <Route path={`${process.env.PUBLIC_URL + "/servicos/tecnologia"}`} element={<Tecnologia/>} />
                  <Route path={`${process.env.PUBLIC_URL + "/servicos/civil"}`} element={<Civil/>} />
                  <Route path={`${process.env.PUBLIC_URL + "/servicos/consultoria"}`} element={<Consultoria/>} />
                  <Route path={`${process.env.PUBLIC_URL + "/blog-classic"}`} element={<BlogClassic/>} />
                  

                  {/* Não utilizados: */}
                  {/* <Route path={`${process.env.PUBLIC_URL + "/blog-classic"}`} element={<BlogClassic/>} />
                  <Route path={`${process.env.PUBLIC_URL + "/work"}`} element={<Work/>} />
                  <Route path={`${process.env.PUBLIC_URL + "/work-details/:id"}`} element={<WorkDetails/>} />
                  <Route path={`${process.env.PUBLIC_URL + "/home-two"}`} element={<HomeTwo/>}/>
                  <Route path={`${process.env.PUBLIC_URL + "/home-three"}`} element={<HomeThree/>}/> */}

                </Routes>
            </Suspense>
        </NavScrollTop>
      </Router>
  );
}

export default App;
